import React from 'react';
import { CampaignPreview } from '../components/CampaignPreview';

const CampaignPreviewSection = ({ form, games, audiences }: any) => {
  const selectedGame = games.find((g: any) => g.id === form.selectedGameId);
  const selectedAudience = audiences.find((a: any) => a.id === form.selectedAudienceId);

  return (
    <div className='bg-white p-8 rounded-2xl'>
      <CampaignPreview
        name={form.campaignName}
        game={selectedGame}
        audience={selectedAudience}
        customGender={form.newGender}
        customAge={form.newAgeRange}
        customLocation={form.locations}
        start={form.startDate}
        end={form.endDate}
        daily={form.dailyBudget}
        totalDays={form.totalDays}
      />
    </div>
  );
};

export default CampaignPreviewSection;